import React from 'react';
import ReportProblemIcon from 'assets/report_problem.svg?react';
import showConfirmModal from 'components/ConfirmModal';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import { RecordSourceType } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';

export type CropSeasonMismatchActionType = 'create' | 'edit' | 'duplicate';

interface CropSeasonMismatchModalOptions {
  actionType?: CropSeasonMismatchActionType;
  recordSourceLabel?: string;
}

const showCropSeasonMismatchModal = (
  onOk: () => void,
  operationType: OperationType = OperationType.APPLICATION,
  recordSourceType: RecordSourceType = operationType ===
  OperationType.APPLICATION
    ? RecordSourceType.APPLICATION
    : RecordSourceType.WORK_ORDER,
  options: CropSeasonMismatchModalOptions = {}
) => {
  const { actionType = 'create', recordSourceLabel } = options;
  const operationTypeDisplay =
    operationType === OperationType.APPLICATION ? 'Application' : 'Work Order';

  const recordSourceTypeDisplay = {
    [RecordSourceType.RECOMMENDATION]: 'Recommendation',
    [RecordSourceType.PLANS]: 'Plan',
    [RecordSourceType.WORK_ORDER]: 'Work Order',
    [RecordSourceType.APPLICATION]: 'Application',
    [RecordSourceType.INVOICE]: 'Invoice',
    [RecordSourceType.INTEGRATIONS]: 'Integration'
  };

  const recordSourceDisplay =
    recordSourceLabel ||
    recordSourceTypeDisplay[recordSourceType] ||
    'source record';

  const sourceDisplays = {
    create: `your ${recordSourceDisplay}`,
    edit: `this ${operationTypeDisplay}`,
    duplicate: `your existing ${operationTypeDisplay}`
  };

  const targetDisplays = {
    create: `to your ${operationTypeDisplay}`,
    edit: `when editing this ${operationTypeDisplay}`,
    duplicate: `to your new ${operationTypeDisplay}`
  };

  const defaultExplanationDisplay = `Some properties selections will not carry over ${targetDisplays[actionType]}.`;
  const explanationDisplay = {
    edit:
      'If you continue, some of your properties selections will be removed.',
    duplicate: defaultExplanationDisplay,
    create: defaultExplanationDisplay
  };

  const okTextDisplay = {
    create: `Create ${operationTypeDisplay}`,
    edit: `Edit ${operationTypeDisplay}`,
    duplicate: `Duplicate ${operationTypeDisplay}`
  };

  showConfirmModal({
    icon: <ReportProblemIcon />,
    width: 423,
    title: <span className="text-base">Mismatch in Crop Season filter</span>,
    content: (
      <p className="text-sm" style={{ maxWidth: 335 }}>
        At least one crop season from {sourceDisplays[actionType]} is not
        currently selected in the Crop Season filter.{' '}
        {explanationDisplay[actionType]}
      </p>
    ),
    contentStyles: {},
    okText: okTextDisplay[actionType],
    okButtonProps: {
      style: {
        borderRadius: 4,
        background: '#14803C',
        padding: '10px 16px',
        color: '#FFF',
        fontSize: 14,
        fontWeight: 400,
        marginLeft: 8,
        outline: 'none'
      }
    },
    cancelText: 'Go back',
    onOk
  });
};

export default showCropSeasonMismatchModal;
